export function getEnumKeyByEnumValue<T extends { [index: string]: string }>(
	theEnum: T,
	enumValue: string
): keyof T | null {
	return Object.keys(theEnum).find((x) => theEnum[x] == enumValue) ?? null
}
